import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { BATCH_SHEET_PARAM } from '~/lib/transfers/utils';

export const useBatchSheet = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const batchId = searchParams.get(BATCH_SHEET_PARAM);

  const openBatchSheet = useCallback(
    (id: string) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set(BATCH_SHEET_PARAM, id);
        return next;
      });
    },
    [setSearchParams]
  );

  const closeBatchSheet = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(BATCH_SHEET_PARAM);
        return next;
      },
      { replace: true }
    );
  }, [setSearchParams]);

  return { batchId, openBatchSheet, closeBatchSheet };
};
